import Vue from 'vue';
import Router from 'vue-router';

const TheContainer = () => import('@/components/TheContainer');
const Page404 = () => import('@/components/views/Page404');
const Login = () => import('@/components/views/Login');

const Dashboard = () => import('@/components/views/Dashboard');
const FiduciaList = () => import('@/components/views/fiducia/FiduciaList');
const FiduciaDetail = () => import('@/components/views/fiducia/FiduciaDetail');
const RoyaList = () => import('@/components/views/roya/RoyaList');
const RoyaDetail = () => import('@/components/views/roya/RoyaDetail');
const AphtListCreated = () => import('@/components/views/apht/AphtListCreated');
const AphtListNeedApproval = () => import('@/components/views/apht/AphtListNeedApproval');
const AphtDetail = () => import('@/components/views/apht/AphtDetail');
const AphtAdd = () => import('@/components/views/apht/AphtAdd');
const AphtEdit = () => import('@/components/views/apht/AphtEdit');
const ValidationFiduciaList = () => import('@/components/views/validation/ValidationFiduciaList');
const ValidationRoyaList = () => import('@/components/views/validation/ValidationRoyaList');
const InvoiceFiduciaList = () => import('@/components/views/payment-fiducia/InvoiceList');
const InvoicePaidFiduciaList = () => import('@/components/views/payment-fiducia/InvoicePaidList');
const InvoiceFiduciaAdd = () => import('@/components/views/payment-fiducia/InvoiceAdd');
const InvoiceFiduciaDetail = () => import('@/components/views/payment-fiducia/InvoiceDetail');
const InvoiceRoyaList = () => import('@/components/views/payment-roya/InvoiceList');
const InvoicePaidRoyaList = () => import('@/components/views/payment-roya/InvoicePaidList');
const InvoiceRoyaAdd = () => import('@/components/views/payment-roya/InvoiceAdd');
const InvoiceRoyaDetail = () => import('@/components/views/payment-roya/InvoiceDetail');
const InvoiceAPHTList = () => import('@/components/views/payment-apht/InvoiceList');
const InvoiceAPHTApprovedList = () => import('@/components/views/payment-apht/InvoiceApprovedList');
const InvoiceAPHTMemoList = () => import('@/components/views/payment-apht/InvoiceMemoList');
const InvoiceAPHTAdd = () => import('@/components/views/payment-apht/InvoiceAdd');
const InvoiceAPHTEdit = () => import('@/components/views/payment-apht/InvoiceEdit');
const InvoiceAPHTDetail = () => import('@/components/views/payment-apht/InvoiceDetail');
const InvoiceAPHTApprovedDetail = () => import('@/components/views/payment-apht/InvoiceApprovedDetail');
const InvoiceAPHTApprovedMemoDetail = () => import('@/components/views/payment-apht/InvoiceApprovedMemoDetail');
const NotarisList = () => import('@/components/views/notaris/NotarisList');
const NotarisAdd = () => import('@/components/views/notaris/NotarisAdd');
const UserList = () => import('@/components/views/user/UserList');
const NotarisEdit = () => import('@/components/views/notaris/NotarisEdit');
const AssignContractList = () => import('@/components/views/contract/AssignContractList');
const AssignContractAddFiducia = () => import('@/components/views/contract/AssignContractAddFiducia');
const AssignContractAddRoya = () => import('@/components/views/contract/AssignContractAddRoya');
const MouAdd = () => import('@/components/views/mou/MouAdd');
const MouEdit = () => import('@/components/views/mou/MouEdit');
const ConfigParameterList = () => import('@/components/views/config/ConfigParameterList');
const ConfigScriptList = () => import('@/components/views/config/ConfigScriptList');
const ConfigScriptAdd = () => import('@/components/views/config/ConfigScriptAdd');
const ConfigScriptEdit = () => import('@/components/views/config/ConfigScriptEdit');
const ConfigDocumentList = () => import('@/components/views/config/ConfigDocumentList');
// const ConfigDocumentAdd = () => import('@/components/views/config/ConfigDocumentAdd');
// const ConfigDocumentEdit = () => import('@/components/views/config/ConfigDocumentEdit');
const ConfigPrincipalList = () => import('@/components/views/config/ConfigPrincipalList');
const ConfigSchedulerList = () => import('@/components/views/config/ConfigSchedulerList');
const ConfigRoleList = () => import('@/components/views/config/ConfigRoleList');
const ConfigApprovalList = () => import('@/components/views/config/ConfigApprovalList');
const ConfigApprovalDetail = () => import('@/components/views/config/ConfigApprovalDetail');
const ConfigPaymentStatus = () => import('@/components/views/config/ConfigPaymentStatus');
const ConfigAssignmentRoya = () => import('@/components/views/config/ConfigAssignmentRoya');
const LogsServerList = () => import('@/components/views/logs/LogsServerList');
const LogsSecurityList = () => import('@/components/views/logs/LogsSecurityList');
const LogsTransactionList = () => import('@/components/views/logs/LogsTransactionList');

// const ActivateAccount = () => import('@/components/views/old/user/ActivateAccount');
// const JobAssignment = () => import('@/components/views/old/JobAssignment');
// const OtherJobAssignment = () => import('@/components/views/old/OtherJobAssignment');
// const DocumentAssignment = () => import('@/components/views/old/DocumentAssignment');
// const ToggleISSOffice = () => import('@/components/views/old/ToggleISSOffice');
// const Reporting = () => import('@/components/views/old/Reporting');
// const QueueDetail = () => import('@/components/views/old/queueDetail');
// const ReasonContainer = () => import('@/components/views/old/ReasonContainer');

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/fims/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
    {
      path: '/',
      redirect: '/dashboard',
      component: TheContainer,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/fiducia',
          name: 'Fiducia',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/fiducia',
              name: 'Fiducia List',
              component: FiduciaList
            },
            {
              path: '/fiducia/:fiduciaId',
              name: 'Fiducia Detail',
              component: FiduciaDetail
            }
          ]
        },
        {
          path: '/roya',
          name: 'Roya',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/roya',
              name: 'Roya List',
              component: RoyaList
            },
            {
              path: '/roya/:royaId',
              name: 'Roya Detail',
              component: RoyaDetail
            }
          ]
        },
        {
          path: '/apht',
          name: 'APHT',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/apht/create',
              name: 'APHT Add',
              component: AphtAdd
            },
            {
              path: '/apht/edit/:contractMemoNo',
              name: 'APHT Edit',
              component: AphtEdit
            },
            {
              path: '/apht/created',
              name: 'APHT List Created',
              component: AphtListCreated
            },
            {
              path: '/apht/need-approval',
              name: 'APHT List Need Approval',
              component: AphtListNeedApproval
            },
            {
              path: '/apht/:contractMemoNo',
              name: 'APHT Detail',
              component: AphtDetail
            },
          ]
        },
        {
          path: '/validation',
          name: 'Validation',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/validation-fiducia',
              name: 'Validation Fiducia List',
              component: ValidationFiduciaList
            },
            {
              path: '/validation-roya',
              name: 'Validation Roya List',
              component: ValidationRoyaList
            },
          ]
        },
        {
          path: '/invoice-fiducia',
          name: 'Invoice Fiducia',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/invoice-fiducia',
              name: 'Invoice Fiducia List',
              component: InvoiceFiduciaList
            },
            {
              path: '/invoice-fiducia/paid',
              name: 'Invoice Paid Fiducia List',
              component: InvoicePaidFiduciaList
            },
            {
              path: '/invoice-fiducia/create',
              name: 'Invoice Fiducia Add',
              component: InvoiceFiduciaAdd
            },
            {
              path: '/invoice-fiducia/:invoiceType/:contractId',
              name: 'Invoice Fiducia Detail',
              component: InvoiceFiduciaDetail
            }
          ]
        },
        {
          path: '/invoice-roya',
          name: 'Invoice Roya',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/invoice-roya',
              name: 'Invoice Roya List',
              component: InvoiceRoyaList
            },
            {
              path: '/invoice-roya/paid',
              name: 'Invoice Paid Roya List',
              component: InvoicePaidRoyaList
            },
            {
              path: '/invoice-roya/create',
              name: 'Invoice Roya Add',
              component: InvoiceRoyaAdd
            },
            {
              path: '/invoice-roya/:invoiceType/:contractId',
              name: 'Invoice Roya Detail',
              component: InvoiceRoyaDetail
            }
          ]
        },
        {
          path: '/invoice-apht',
          name: 'Invoice APHT',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/invoice-apht',
              name: 'Invoice APHT List',
              component: InvoiceAPHTList
            },
            {
              path: '/invoice-apht/created',
              name: 'Invoice APHT Approved List',
              component: InvoiceAPHTApprovedList
            },
            {
              path: '/invoice-apht/:invoiceMemoNo',
              name: 'Invoice APHT Detail',
              component: InvoiceAPHTDetail
            },
            {
              path: '/invoice-apht/created/:collateralId',
              name: 'Invoice APHT Memo List',
              component: InvoiceAPHTMemoList
            },
            {
              path: '/invoice-apht/created/create/:collateralId',
              name: 'Invoice APHT Add',
              component: InvoiceAPHTAdd
            },
            {
              path: '/invoice-apht/created/invoice/:invoiceType/:collateralId',
              name: 'Invoice APHT Approved Detail',
              component: InvoiceAPHTApprovedDetail
            },
            {
              path: '/invoice-apht/created/:collateralId/:invoiceMemoNo',
              name: 'Invoice APHT Approved Memo Detail',
              component: InvoiceAPHTApprovedMemoDetail
            },
            {
              path: '/invoice-apht/created/:collateralId/:invoiceMemoNo/edit',
              name: 'Invoice APHT Edit',
              component: InvoiceAPHTEdit
            }
          ]
        },
        {
          path: '/notaris',
          name: 'Notaris',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/notaris',
              name: 'Notaris List',
              component: NotarisList
            },
            {
              path: '/notaris/create',
              name: 'Notaris Add',
              component: NotarisAdd
            },
            {
              path: '/notaris/edit/:notarisId',
              name: 'Notaris Edit',
              component: NotarisEdit
            }
          ]
        },
        {
          path: '/contract',
          name: 'Contract',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/contract',
              name: 'Assign Contract List',
              component: AssignContractList
            },
            {
              path: '/contract/fiducia/:contractParams',
              name: 'Assign Contract Fiducia',
              component: AssignContractAddFiducia
            },
            {
              path: '/contract/roya/:contractParams',
              name: 'Assign Contract Roya',
              component: AssignContractAddRoya
            }
          ]
        },
        {
          path: '/mou',
          name: 'Mou',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/mou/create/:notarisId',
              name: 'MOU Add',
              component: MouAdd
            },
            {
              path: '/mou/edit/:notarisId/:mouId',
              name: 'MOU Edit',
              component: MouEdit
            },
          ]
        },
        {
          path: '/user',
          name: 'User',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/user',
              name: 'User List',
              component: UserList
            }
          ]
        },
        {
          path: '/config/parameter',
          name: 'Config Parameter',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/config/parameter',
              name: 'Config Parameter List',
              component: ConfigParameterList
            }
          ]
        },
        {
          path: '/config/script',
          name: 'Config Script',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/config/script',
              name: 'Config Script List',
              component: ConfigScriptList
            },
            {
              path: '/config/script/create',
              name: 'Config Script Add',
              component: ConfigScriptAdd
            },
            {
              path: '/config/script/edit/:scriptId',
              name: 'Config Script Edit',
              component: ConfigScriptEdit
            },
          ]
        },
        {
          path: '/config/document',
          name: 'Config Document',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/config/document',
              name: 'Config Document List',
              component: ConfigDocumentList
            },
            // {
            //   path: '/config/document/create',
            //   name: 'Config Document Add',
            //   component: ConfigDocumentAdd
            // },
            // {
            //   path: '/config/document/edit/:documentId',
            //   name: 'Config Document Edit',
            //   component: ConfigDocumentEdit
            // }
          ]
        },
        {
          path: '/config/principal',
          name: 'Config Principal',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/config/principal',
              name: 'Config Principal List',
              component: ConfigPrincipalList
            }
          ]
        },
        {
          path: '/config/scheduler',
          name: 'Config Scheduler',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/config/scheduler',
              name: 'Config Scheduler List',
              component: ConfigSchedulerList
            }
          ]
        },
        {
          path: '/config/role',
          name: 'Config Role',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/config/role',
              name: 'Config Role List',
              component: ConfigRoleList
            },
          ]
        },
        {
          path: '/config/approval/:by',
          name: 'Config Approval List',
          component: ConfigApprovalList
        },
        {
          path: '/config/approval/:by/:by2/:code',
          name: 'Config Approval Detail',
          component: ConfigApprovalDetail
        },
        {
          path: '/config/payment-status',
          name: 'Config Payment Status',
          component: ConfigPaymentStatus
        },
        {
          path: '/config/assignment-roya',
          name: 'Config Assignment Roya',
          component: ConfigAssignmentRoya
        },
        {
          path: '/logs/server',
          name: 'Logs Server List',
          component: LogsServerList
        },
        {
          path: '/logs/security',
          name: 'Logs Security List',
          component: LogsSecurityList
        },
        {
          path: '/logs/transaction',
          name: 'Logs Transaction List',
          component: LogsTransactionList
        },
        // {
        //   path: '/JobAssignment',
        //   name: 'Navigation',
        //   component: {
        //     render (c) { return c('router-view')}
        //   },
        //   children: [{
        //     path: '/JobAssignment/:serviceId?/:networkId?/',
        //     name: 'JobAssignment',
        //     component: JobAssignment,
        //     props(route){
        //       const props = {...route.params};
        //       Object.keys(props).forEach(prop => {
        //         if (props[prop]){
        //           props[prop] = props[prop].toString();
        //         }
        //       });
        //       return props;
        //       },
        //     }, {
        //       path: '/OtherJobAssignment',
        //       name: 'OtherJobAssignment',
        //       component: OtherJobAssignment,
        //     }, {
        //       path: '/ToggleISSOffice',
        //       name: 'ToggleISSOffice',
        //       component: ToggleISSOffice,
        //     }, {
        //       path: '/DocumentAndSLAAssignment/:actionType?/:serviceId?',
        //       name: 'DocumentAssignment',
        //       component: DocumentAssignment,
        //       props: true
        //     }, {
        //       path: '/Reporting/:reportType',
        //       name: 'Reporting',
        //       component: Reporting,
        //       props: true
        //     }, {
        //       path: '/QueueDetail/:queueIdProp?',
        //       name: 'QueueDetail',
        //       component: QueueDetail,
        //       props(route){
        //         const props = {...route.params};
        //         props.queueIdProp = parseInt(props.queueIdProp);
        //         return props;
        //       },
        //     }, {
        //       path: '/DaftarReason/:header',
        //       name: 'DaftarReason',
        //       component: ReasonContainer,
        //       props: true
        //     }
        //   ]
        // },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    // {
    //   path: '/user/activate/:id',
    //   name: 'Account Activation',
    //   component: ActivateAccount
    // },
    {
      path: '/*',
      name: 'Page 404',
      component: Page404
    }
  ]
}
